export const BreadcrumbElements = {
  BreadcrumbParentId: 'extra-crumbs',
  BreadcrumbElementTagName: 'shell_he-breadcrumb-item',
  BreadcrumbParentTagName: 'shell_he-breadcrumb',
  ShellQuerySelector: 'he-shell',
  ShellBreadcrumbElement: 'he-shell-breadcrumb',
  BreadcrumbWorkspaceNode: 'breadcrumb-workspaceNode',
  ShellBreadcrumbEventName: 'breadcrumbready',
};
